import Repository from '../axios'

export default {
  createShipment(payload) {
    return Repository.post(`/admin/dhl/shipments`, payload)
  },
  checkAvailableProducts(query) {
    return Repository.get(`/admin/dhl/products?${query}`)
  },
  fetchShipmentTrackingData(tracking_id) {
    return Repository.get(`/admin/dhl/shipments/${tracking_id}/tracking`)
  },
  checkShipmentRates(payload) {
    return Repository.post(`/admin/dhl/rates`, payload)
  },
};
